<template lang="html">
  <div>

    <div class="select-question container wrap">

      <div class="select-question__left flex-grow-1 flex-basis-200">
        <div class="game-config">
          <div class="game-config-title ">
            MEMORY GAME
          </div>

          <div class="game-config-content ">
            <div class="game-config-item container column margin-bottom-20">
              <strong>
                MOVES
              </strong>
              <span>
                {{ question.answered ? question.attempts : attempts }}
              </span>
            </div>

            <div class="game-config-item container column">
              <strong>
                MOVES
              </strong>
              <span>
                000
              </span>
            </div>
          </div>
          <div class="game-config-footer ">
          </div>
        </div>
      </div>


      <div class="select-question__right flex-grow-2 flex-basis-600">
        <div class="container wrap">
          <div
            v-for="(aswr, index) in cards"
            class="item text-align-center exercise-screen__card animation-bottom"
            :style="{animationDelay: (index / 20) + 's'}"
            :key="`aswr-${index}`"
          >
            <div :ref="`card-${index}`" class="container justify-content-center exercise-screen__card__content" @click="flip(index, aswr)"
              :class="{ 'exercise-screen__card--green': aswr.selected }">
              <div class="exercise-screen__card__content exercise-screen__card__content--front">
                <p v-if="aswr.card">{{ aswr.card }}</p>
                <img :src="aswr.image" v-if="aswr.image" />
              </div>
              <!-- <div class="exercise-screen__card__content exercise-screen__card__content--back" :class="{ blue: aswr.card }"> -->
              <div class="exercise-screen__card__content exercise-screen__card__content--back">
                <img src="@/assets/img/game/logo-card-blue.svg" width="30" alt="Minds" class="logo">
                <img src="@/assets/img/game/turn-blue.svg" width="30" alt="Minds" class="turn">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>
        <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Memoryexercise",
  data() {
    return {
      question: {
        answers: []
      },
      pair: {
        first: null,
        second: null
      },
      cards: [],
      hits: 0,
      attempts: 0,
      ended: false,
      showInfo: false,
      showFeedback: false,
      index: 0
    }
  },
  props: {
    subTopic: {
      type: Object,
      default: () => ({})
    },
    topic: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise() {
      return this.subTopic.exercise;
    }
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    async setCurrent() {
      let qst          = {},
          currentIndex = 0

      const questions = this.exercise.questions

      for (const index in questions) {
        currentIndex = index
        if (!questions[index].answered) {
          qst = questions[index]
          break;
        } else if (index == questions.length - 1) {
          qst = questions[index]
          this.ended = true
        }
      }
      this.index = currentIndex;
      if (
        Object.keys(this.question).length == 0 ||
        qst._id !== this.question._id
      ) {
        this.shuffleArray(qst.answers)
        this.$set(this, "question", qst)
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    shuffleArray(arr) {
      let array = this.doubleArray(arr)
      this.cards = this.$shuffle(array)
    },
    doubleArray(arr) {
      const array = cloneDeep(arr),
            text  = array.map((x, index) => {
        return { card: x.card, selected: x.selected, correct: index }
      })
      const image = array.map((x, index) => {
        return { image: x.image, selected: x.selected, correct: index }
      })
      return cloneDeep([...text, ...image]);
    },
    async flip(ind, card) {
      if (
        ((!this.pair.first && !this.pair.second) ||
          (this.pair.first && !this.pair.second)) &&
        !card.selected
      ) {
        if (!this.$refs[`card-${ind}`][0].classList.contains("flipped")) {
          this.$refs[`card-${ind}`][0].classList.toggle("flipped");
          if (this.pair.first === null)
            this.pair.first = { index: ind, card: card };
          else {
            if (this.pair.second === null) {
              this.pair.second = { index: ind, card: card };
              await this.$delay(1000);
              if (
                this.pair.first.card.correct == this.pair.second.card.correct
              ) {
                let prop = "";
                if (this.pair.first.card.hasOwnProperty("card")) prop = "card";
                else prop = "image";
                const index = this.question.answers.findIndex(x => {
                  if (prop == "image")
                    return this.pair.first.card[prop].indexOf(x[prop]) > -1;
                  return this.pair.first.card[prop] === x[prop];
                });
                this.markRight(index, this.pair);
                this.hits++;
              } else {
                this.unflip(this.pair.first.index, this.pair.second.index);
              }
              this.attempts++;
              if (this.hits == this.question.answers.length) {
                await this.$delay(250);
                this.$set(this.question, "answered", true);
                this.$set(this.question, "hit", true);
                this.$set(this.question, "attempts", this.attempts);
                this.feedback()
                await this.save(cloneDeep(this.question));
                this.hits = 0;
                this.attempts = 0;
              }
              this.pair.first = null;
              this.pair.second = null;
            }
          }
        }
      }
    },
    markRight(index, pair) {
      this.$set(this.question.answers[index], "selected", true);
      this.$set(this.cards[pair.first.index], "selected", true);
      this.$set(this.cards[pair.second.index], "selected", true);
    },
    unflip(ind1, ind2) {
      this.$refs[`card-${ind1}`][0].classList.toggle("flipped");
      this.$refs[`card-${ind2}`][0].classList.toggle("flipped");
    },
    calcPossibilities(numCards) {
      const pairs = [];
      for (let x = 1; x <= numCards; x++) {
        if (x % 2 == 0) pairs.push(x);
      }
      return pairs.reduce((acc, cur) => {
        if (!acc) acc = 0;
        return (acc += cur - 1);
      });
    },
    async save(question) {
      let score = 0;
      let finished = 0;

      for (const qst of this.exercise.questions) {
        if (qst.answered) {
          const possibilities = this.calcPossibilities(qst.answers.length * 2);

          if (qst.attempts > possibilities)
            score += 0;
          else
            score +=
              100 -
              parseFloat(
                (
                  ((qst.attempts - qst.answers.length) * 100) /
                  possibilities
                ).toFixed(2)
              );

          finished++;
        }
      }

      const finalScore = parseFloat(
        (score / this.exercise.questions.length).toFixed(2)
      );

      let payload = {
        points: finalScore,
        finished: false,
        question: { ...question }
      };

      if (finished == this.exercise.questions.length) {
        this.ended = true
        payload.finished = true
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit("updateProgress", finalScore);
      gameBus.$emit("setEnabled", true);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    async viewQuestion(index) {
      const question = this.exercise.questions[index];
      if (question && question.answered) {
        this.index = index;
        this.shuffleArray(question.answers);
        this.$set(this, "question", question);
      }
    },
    async feedback () {
      this.showFeedback = true
      await this.$delay(1500)
      this.showFeedback = false
      gameBus.$emit('setEnabled', true)
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    closeModal () {
      this.showInfo = false
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  mounted() {
    this.setCurrent()
    gameBus.$on("viewQuestion", this.viewQuestion)

    gameBus.$emit("updateProgress", this.subTopic.points)
    modalBus.$on("close", this.closeModal)
    gameBus.$on("setCurrent", this.setCurrent)
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion)

    modalBus.$off('close', this.closeModal)
    gameBus.$off("setCurrent", this.setCurrent)
  }
};
</script>

<style lang="scss" scoped>
@import './src/assets/css/base/variables';

.game-config {
  border: 2px solid #f48900;
  background: #fff;
  // height: calc(100% - 15px);
  border-radius: 10px;
  margin: 8px;
}

.game-config-title {
  background: #f48900;
  padding: 24px 20px;
  text-align: center;
  color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.game-config-content {
  padding: 20px 0;
}

.game-config-footer {
  background: #f48900;
  padding: 10px 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.game-config-item {
  padding: 20px 20px;
  background: #cecece;
  text-align: center;

  strong {
    color: #7d7d7d;
    font-weight: bold;
  }

  span {
    color: #f48900;
    font-size: 2rem;
  }
}

.exercise-screen__card {
  padding: 8px;
  width: 20%;
  height: 180px;
  position: relative;
  margin: 0;

  @media (max-width: 768px) {
    width: 25%;
  }

  @media (max-width: 576px) {
    width: 50%;
  }

  & .exercise-screen__card__content {
    width: 100%;
    height: 100%;
    border-radius: 15px;
    box-shadow: 0px 0px 15px 2.5px rgb(236, 236, 236);
    transition: all 0.3s ease 0s;
    transform-style: preserve-3d;
    position: relative;
    top: 0;
    margin: 0;
    &.exercise-screen__card--green {
      transform: rotateY(180deg);
      & .exercise-screen__card__content {
        border: 1px solid green;
      }
    }
    &.flipped {
      transform: rotateY(180deg);
    }
    &.canflip:hover {
      cursor: pointer;
      transform: translateY(-5px);
      box-shadow: 0px 5px 15px 2.5px rgb(236, 236, 236);
    }
    &:active {
      // transform: translateY(-3px) !important;
      top: -3px;
    }
    .exercise-screen__card__content {
      border: 1px solid #ddd;
      margin: 0;
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      display: flex;
      justify-content: center;
      color: #fff;
      &.exercise-screen__card__content--front {
        background: #ff7665;
        transform: rotateY(180deg);
        overflow: hidden;

        img {
          width: 100%;
          height: 162px;
          object-fit: cover;
          object-position: center;
        }
      }
      &.exercise-screen__card__content--back {
        background: #ff7665;
        background-image: url("../../assets/img/game/bg-card-orange.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        &.blue {
          background: #2ddbc3;
          background-image: url("../../assets/img/game/bg-card-blue.jpg");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }
        .turn {
          display: none;
        }
        &.canflip:hover {
          filter: saturate(1.5);
          .turn {
            display: block;
          }
          .logo {
            display: none;
          }
        }
        img {
          height: 75px;
        }
      }
      & img {
        width: 100px;
        height: 100px;
      }
      & p {
        text-transform: uppercase;
        font-weight: 600;
      }
      & img,
      p {
        margin: auto;
      }
    }
  }
}

.correct_result,
.wrong_result {
  font-weight: bold;
}

.correct_result {
  color: $color-green !important;
}

.wrong_result {
  color: $color-red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/game/memoryGame.vue